import React from "react";
import { Link } from "react-router-dom";
import { SecondaryButton } from "../../../components/buttons/AmeButton";
import Data from "../../../data/Data";
import PropTypes from "prop-types";

const RevisionsButton = props => {
    const appTypes = Data.getAppTypes();
    const {
        miniApp,
        informations,
        miniApp: { type }
    } = props;
    return (
        <Link
            className={
                type === appTypes.EITRI_TYPE_ENGINE
                    ? "mini-app-list--cursor-active"
                    : "mini-app-list--cursor-default"
            }
            to={{
                pathname: `/eitri-app-management/eitri-apps/${miniApp.id}/revisions`,
                dataProps: { miniApp, informations }
            }}
        >
            <SecondaryButton
                size={"sm"}
                disabled={
                    type !== appTypes.EITRI_TYPE_ENGINE ||
                    !miniApp.revisions ||
                    miniApp.revisions.length === 0
                }
            >
                Versões
            </SecondaryButton>
        </Link>
    );
};

RevisionsButton.propTypes = {
    slug: PropTypes.string,
    type: PropTypes.string,
    miniApp: PropTypes.object,
    informations: PropTypes.object
};

export default RevisionsButton;
